import { ApiService } from '../../../../ApiService';
import { FilterState } from '../../../../../containers/applicant_tracking/Analytics/Filters';
import { mapToParams } from '../../mapToParams';

interface GroupBy {
  heatmapGroupBy?: string;
  rejectionGroupBy?: string;
}

function buildParams(filterState?: FilterState, groupBy?: GroupBy) {
  return {
    ...mapToParams(filterState),
    ...(groupBy?.heatmapGroupBy != null && {
      heatmap_group_by: groupBy.heatmapGroupBy,
    }),
    ...(groupBy?.rejectionGroupBy != null && {
      rejection_group_by: groupBy.rejectionGroupBy,
    }),
  };
}

export class ExportsService {
  public static pdf(
    filterState?: FilterState,
    groupBy?: GroupBy,
  ): Promise<Blob> {
    return ApiService.get(
      '/applicant_tracking/analytics/pipeline_performance/exports/pdf',
      buildParams(filterState, groupBy),
    );
  }

  public static csv(
    filterState?: FilterState,
    groupBy?: GroupBy,
  ): Promise<Blob> {
    return ApiService.get(
      '/applicant_tracking/analytics/pipeline_performance/exports/csv',
      buildParams(filterState, groupBy),
    );
  }
}
